module.exports = __webpack_public_path__ + "static/media/cup.7b52aae1.png";